var alertNotifications = {
	alert: {
		limitAbove: "Upper limit crossed",
		limitBelow: "Lower limit crossed"
	},
	closeBtn: "Close",
	openHistory: "Open alert history"
};
var en = {
	alertNotifications: alertNotifications
};

export { alertNotifications, en as default };
